export const ALLOWED_EXCEL_EXTENSIONS = [".xlsx"];
